import _ from 'lodash';

import templates from '../templates';
import colorSwatch from '../tools/color-swatch';
import ColorFlatUI from '../tools/colorflatui';
import translate from '../tools/translate';

const additionalArea = (() => {
    let $dialog = null;
    let $template = null;

    const _onClose = onCancel => {
        if (_.isFunction(onCancel)) {
            onCancel();
        }

        $dialog.destroy();
        $template.remove();
    };

    return ({ types, value = {}, confirmed = false, onChangeType, onChangeStyle, onToggleTag, onCancel }) => {
        let _confirmed = confirmed;

        $template = $(templates('dialog-additional-area'));

        const colors = _.map(ColorFlatUI, (theme, text) => ({
            text,
            value: theme[1][0],
            template: colorSwatch(theme[1][0])
        }));

        $template.find('select[name="locationType"]').kendoDropDownList({
            dataTextField: 'text',
            dataValueField: 'value',
            optionLabel: translate('Action.Select'),
            dataSource: types,
            value: value.locationType,
            change: e => {
                if (!e.sender.value()) {
                    return;
                }

                _confirmed = true;
                onChangeType(Number(e.sender.value()));
            }
        });

        $template.find('select[name="color"]').kendoDropDownList({
            dataTextField: 'text',
            dataValueField: 'value',
            valueTemplate: `<img style="height: 20px; margin: -2px 0 0 -8px;" src="#: data.template #">`,
            template: `<img style="margin: 0 0 0 -5px" src="#: data.template #">`,
            dataSource: colors,
            value: value.color,
            change: e => onChangeStyle({ color: e.sender.value() })
        });

        $template.find('select[name="weight"]').kendoDropDownList({
            dataTextField: 'text',
            dataValueField: 'value',
            dataSource: _.times(10, i => ({ text: String(i + 1), value: i + 1 })),
            value: value.weight,
            change: e => onChangeStyle({ weight: Number(e.sender.value()) })
        });

        const $tag = $template.find('input[name="tag"]');

        $tag.iCheck({
            checkboxClass: 'icheckbox_square-blue',
            radioClass: 'iradio_square-blue'
        });

        if (value.tag) {
            $tag.iCheck('check');
        }

        $tag.on('ifChanged', e => onToggleTag(e.target.checked));

        $dialog = $template
            .kendoWindow({
                width: '300px',
                resizable: false,
                draggable: true,
                visible: false,
                title: translate('Common.AdditionalArea'),
                appendTo: 'body',
                close: () => _onClose(_confirmed ? null : onCancel)
            })
            .data('kendoWindow');

        $dialog.center().open();

        return $dialog;
    };
})();

export default additionalArea;



// WEBPACK FOOTER //
// ./src/scripts/core/dialog/additional-area.js